import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import {
  getThemeColor,
  inputSelect,
  inputSelectWhite
} from '../../utils/styles';
import ChevronDown from '../../images/svg/chevron-down.svg';
import { Flex } from '../UIKit/system';
import InputLabel from './input-label';

const StyledInputSelect = styled.div`
  ${inputSelect};
  overflow: hidden;
  border: 1px solid transparent;

  ${(props) =>
    props.white &&
    css`
      ${inputSelectWhite(props)}
    `};

  ${(props) =>
    props.whiteBordered &&
    css`
      ${inputSelectWhite(props)}
      border: 1px ${getThemeColor('borderLight')} solid;
      color: ${getThemeColor('black')};
    `};

  ${(props) =>
    props.boldText &&
    css`
      font-weight: 700;
    `}

  ${(props) =>
    props.invalid &&
    css`
      border: 1px solid ${getThemeColor('danger')};
    `};
`;

const StyledChevronDown = styled(ChevronDown)`
  fill: #fff;

  ${(props) =>
    props.white &&
    css`
      fill: #666;
    `};
`;

const Current = styled.div`
  ${(props) =>
    props.textAlignCenter &&
    css`
      width: 100%;
      text-align: center;
      padding-left: 11px;
    `};
`;

const Select = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  height: 128px;
  border-top: 64px solid transparent;
`;

function InputSelect({
  field,
  options,
  placeholder,
  white,
  whiteBordered,
  textAlignCenter,
  boldText,
  invalid,
  showNone = true
}) {
  const selectedOption = useMemo(() => {
    if (!field.value) {
      return null;
    }

    return options.find((v) => {
      if (v.values) {
        return v.values.find((sv) => sv.value === field.value);
      }

      return v.value === field.value;
    });
  }, [field.value]);

  const renderSelectionName = () => {
    if (!selectedOption) return;

    if (selectedOption.values) {
      return [
        selectedOption.name,
        selectedOption.values.find((value) => value.value === field.value)?.name
      ]
        .filter(Boolean)
        .join(' - ');
    }

    return selectedOption.name;
  };

  return (
    <StyledInputSelect
      white={white}
      whiteBordered={whiteBordered}
      boldText={boldText}
      invalid={invalid}
    >
      <Flex
        height={'100%'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Current textAlignCenter={textAlignCenter}>
          {renderSelectionName() || placeholder || 'Please, select'}
        </Current>
        <StyledChevronDown white={white || whiteBordered} />
      </Flex>
      <Select {...field}>
        {showNone && <option value="">None</option>}
        {options.map((option) => {
          if ('values' in option) {
            return (
              <optgroup key={option.name} label={option.name}>
                {option.values.map((value) => (
                  <option key={value.value} value={value.value}>
                    {value.name}
                  </option>
                ))}
              </optgroup>
            );
          }

          return (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          );
        })}
      </Select>
    </StyledInputSelect>
  );
}

InputSelect.Label = InputLabel;

export default InputSelect;
